import { defineComponent as x, useSlots as $, useCssModule as C, ref as I, computed as s, withDirectives as S, createCommentVNode as i, createElementBlock as l, openBlock as o, normalizeClass as r, createVNode as w, createElementVNode as f, unref as t, renderSlot as m } from "vue";
import y from "lodash-es/capitalize";
import B from "lodash-es/uniqueId";
import { S as M, a as N } from "./statusLevels-D8EgtE_L.js";
import V from "./directives/sticky.js";
import p from "./Icon.js";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const z = { class: "tw-m-0" }, A = /* @__PURE__ */ x({
  name: "ll-alert",
  __name: "Alert",
  props: {
    centered: { type: Boolean, default: !1 },
    permanent: { type: Boolean, default: !1 },
    radius: { default: "standard" },
    severity: { default: "info" },
    sticky: { default: null },
    variant: { default: "outlined" }
  },
  setup(b) {
    const e = b, g = B("close-icon"), _ = $(), a = C(), c = I(!0), u = s(() => M[y(e.severity)]), h = s(() => N[y(e.severity)]), k = s(() => e.variant === "filled" && ["warning", "success"].includes(e.severity) ? "tw-text-ice-900" : e.variant === "filled" && ["info", "error"].includes(e.severity) ? "tw-text-white" : `tw-text-${h.value}`), n = s(() => e.variant === "filled" && ["info", "error"].includes(e.severity) ? "tw-text-white" : "tw-text-ice-900");
    return (d, v) => c.value ? S((o(), l("div", {
      key: 0,
      class: r(["stash-alert tw-relative tw-flex tw-items-center tw-border tw-border-solid tw-p-3 tw-leading-6", [
        `stash-alert--${e.severity}`,
        `stash-alert--${e.variant}`,
        n.value,
        {
          "tw-my-6": e.variant === "outlined",
          // Todo - this makes ZERO sense. We should remove this altogether and let the consumer handle the margin.
          "tw-rounded": e.radius === "standard",
          "tw-border-red-500": e.severity === "error",
          "tw-border-orange-500": e.severity === "warning",
          "tw-border-blue-500": e.severity === "info",
          "tw-border-green-500": e.severity === "success",
          "tw-bg-red-500": e.severity === "error" && e.variant === "filled",
          "tw-bg-orange-500": e.severity === "warning" && e.variant === "filled",
          "tw-bg-blue-500": e.severity === "info" && e.variant === "filled",
          "tw-bg-green-500": e.severity === "success" && e.variant === "filled",
          "tw-bg-red-100": e.severity === "error" && e.variant === "outlined",
          "tw-bg-orange-100": e.severity === "warning" && e.variant === "outlined",
          "tw-bg-blue-100": e.severity === "info" && e.variant === "outlined",
          "tw-bg-green-100": e.severity === "success" && e.variant === "outlined"
        }
      ]]),
      "data-test": "stash-alert"
    }, [
      w(p, {
        class: r(["stash-alert__icon", [t(a).iconInfo, k.value, `stash-alert__icon--${u.value}`]]),
        name: u.value,
        title: `${e.severity} icon`,
        "data-test": "stash-alert|status-icon"
      }, null, 8, ["class", "name", "title"]),
      f("div", {
        class: r(["tw-flex tw-flex-1 tw-flex-wrap tw-px-2", {
          "tw-justify-center": e.centered,
          "tw-justify-between": !e.centered
        }])
      }, [
        f("p", z, [
          m(d.$slots, "default")
        ]),
        t(_).link ? (o(), l("div", {
          key: 0,
          class: r(["stash-alert__link tw-cursor-pointer tw-underline hover:tw-no-underline", [t(a).link, n.value, { "tw-ml-2": e.centered }]]),
          "data-test": "stash-alert|link"
        }, [
          m(d.$slots, "link")
        ], 2)) : i("", !0)
      ], 2),
      e.permanent ? i("", !0) : (o(), l("button", {
        key: 0,
        class: r(["stash-alert__close", [t(a).button, n.value]]),
        type: "button",
        "data-test": "stash-alert|close",
        onClick: v[0] || (v[0] = (q) => c.value = !1)
      }, [
        w(p, {
          id: t(g),
          name: "close",
          title: "Dismiss alert"
        }, null, 8, ["id"])
      ], 2))
    ], 2)), [
      [t(V), e.sticky]
    ]) : i("", !0);
  }
}), D = {}, E = {
  $style: D
}, O = /* @__PURE__ */ j(A, [["__cssModules", E]]);
export {
  O as default
};
//# sourceMappingURL=Alert.js.map
